import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    dueDate: {
      inputType: 'text',
      title: 'Due Date',
      type: 'date',
      value: '',
    },
    custom1: {
      inputType: 'custom',
      title: '',
    },
    coverageAmount: {
      inputType: 'text',
      title: 'Coverage Amount',
      type: 'thousandSep',
      value: '',
    },
    policyNumber: {
      inputType: 'text',
      title: 'Policy Number',
      value: '',
    },
    insuranceEscrowed: {
      inputType: 'radio',
      options: ['Yes', 'No'],
      title: 'Insurance Escrowed',
      value: '',
    },
    insuranceType: {
      inputType: 'radio',
      options: ['Flood', 'Wind/Storm', 'Hazard', 'Earthquake'],
      title: 'Type of Insurance',
      value: '',
    },
    mortgageClauseCpl: {
      inputType: 'select',
      title: 'Mortgage Clause CPL',
      options: {},
      hasDefaultOption: true,
      sort: true,
      sortKey: 'value',
    },
    mortgageClauseInsurance: {
      inputType: 'select',
      title: 'Mortgage Clause Insurance',
      options: {},
      hasDefaultOption: true,
      sort: true,
      sortKey: 'value',
    },
    note: {
      inputType: 'textarea',
      title: 'Notes',
      span: 'full',
    },
  }
}
